// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__25lkA","title":"InfoRow_title__39tbF"};